window.$ = window.jQuery = require('jquery');
require('./misc/misc');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js